import * as yup from 'yup';

export const createCandidatePositionSubscriptionValidationSchema = yup.object({
  email: yup
    .string()
    .email('Invalid email format')
    .required('Email is required')
    .nullable(),
  name: yup.string().required('Name is required').nullable(),
  locations: yup
    .array()
    .of(yup.string().required('Country is required'))
    .min(1, 'Select at least one country')
    .nullable()
    .required('Country is required'),
  technicalFlows: yup
    .array()
    .of(yup.string().required('Specialization is required'))
    .min(1, 'Select at least one specialization')
    .nullable()
    .required('Specialization is required'),
  experience: yup
    .number()
    .min(0, 'Experience must be a positive number')
    .required('Experience is required')
    .nullable(),
});
